export { SimplifiedBlockDeviceModal } from './SimplifiedBlockDeviceModal.ctrl';
export type { SimplifiedBlockDeviceModalProps } from './SimplifiedBlockDeviceModal.model';
